package com.dignicate.web.ui.layout

import androidx.compose.runtime.Composable
import androidx.compose.runtime.LaunchedEffect
import androidx.compose.runtime.getValue
import androidx.compose.runtime.mutableStateOf
import androidx.compose.runtime.remember
import androidx.compose.runtime.setValue
import kotlinx.browser.window
import kotlinx.coroutines.awaitCancellation
import org.w3c.dom.events.Event

enum class Breakpoint { Mobile, Tablet, Desktop }

object Breakpoints {
    const val MOBILE_MAX = 768
    const val TABLET_MAX = 1024
}

@Composable
fun rememberBreakpoint(): Breakpoint {
    var width by remember { mutableStateOf(window.innerWidth) }

    LaunchedEffect(Unit) {
        val listener: (Event) -> Unit = {
            width = window.innerWidth
        }
        window.addEventListener("resize", listener)
        try {
            awaitCancellation()
        } finally {
            window.removeEventListener("resize", listener)
        }
    }

    return when {
        width < Breakpoints.MOBILE_MAX -> Breakpoint.Mobile
        width < Breakpoints.TABLET_MAX -> Breakpoint.Tablet
        else -> Breakpoint.Desktop
    }
}
